import React from 'react';
import { Tooltip } from '@nextiva/next-ui-components';
import { Help } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { HintStyles } from './Hint.styles.ts';

export const Hint = ({
  id = '',
  placement = 'bottom',
  label = '',
  shrink = false,
  tooltipText = '',
  showRed,
}) => {
  return (
    <HintStyles id={id} shrink={shrink}>
      <span className={showRed ? 'hint__label hint__error' : 'hint__label'}>
        {label}
      </span>
      {/* TODO: the font-size for MuiTooltip-popper needs to be adjusted from within PA's styles */}
      {tooltipText && (
        <Tooltip
          placement={placement}
          title={tooltipText}
          data-testid={`PlatformAdminUI-Tooltip-${placement}`}
        >
          <Help className="tooltip" role="presentation" />
        </Tooltip>
      )}
    </HintStyles>
  );
};

Hint.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  placement: PropTypes.string,
  showRed: PropTypes.bool,
  shrink: PropTypes.bool,
  tooltipText: PropTypes.string,
};
